module.exports = __webpack_public_path__ + "static/media/icon_estado_finalizado.c13bed03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_estado_finalizado.svg
// module id = 328
// module chunks = 0